'use client';

import { Check, Pencil, RotateCcw, Trash2 } from 'lucide-react';

import { Button } from '@/components/ui/button';

import { useVideoRecording } from '../../video-recording-provider';

type ActionButtonsProps = {
	variant: 'review' | 'saved';
};

export function ActionButtons({ variant }: ActionButtonsProps) {
	const { retakeWithConfirmation, deleteSavedVideo, saveVideo, editSavedVideo } =
		useVideoRecording();

	if (variant === 'saved') {
		return (
			<div className="mt-2 flex items-center justify-center gap-2">
				<Button
					type="button"
					variant="outline"
					onClick={editSavedVideo}
				>
					<Pencil className="h-4 w-4" /> Edit
				</Button>
				<Button
					type="button"
					variant="outline"
					onClick={deleteSavedVideo}
				>
					<Trash2 className="h-4 w-4" /> Delete
				</Button>
			</div>
		);
	}

	// variant === 'review' (for preview and edit states)
	return (
		<div className="mt-2 flex items-center justify-center gap-2">
			<Button
				type="button"
				variant="outline"
				onClick={retakeWithConfirmation}
			>
				<RotateCcw className="h-4 w-4" /> Retake
			</Button>
			<Button
				type="button"
				variant="outline"
				onClick={deleteSavedVideo}
			>
				<Trash2 className="h-4 w-4" /> Delete
			</Button>
			<Button
				type="button"
				variant="default"
				onClick={saveVideo}
			>
				<Check className="h-4 w-4" /> Save
			</Button>
		</div>
	);
}
